const WELCOME_IMAGE_SELECTION_SEED = Math.random().toString(36).slice(2);

const isAbsoluteHttpUrl = url => {
  try {
    const parsedUrl = new URL(url);
    return ['http:', 'https:'].includes(parsedUrl.protocol);
  } catch {
    return false;
  }
};

const getImageSelectionIndex = ({ options, selectionSeed }) => {
  if (options.length === 1) {
    return 0;
  }

  const hashInput = `${selectionSeed}:${options.join('|||')}`;
  let hash = 0;

  for (let index = 0; index < hashInput.length; index += 1) {
    hash = (hash * 31 + hashInput.charCodeAt(index)) % 2147483647;
  }

  return hash % options.length;
};

export const normalizeWelcomeImageUrls = urls => {
  if (!Array.isArray(urls)) {
    return [];
  }

  return urls.reduce((result, url) => {
    if (typeof url !== 'string') {
      return result;
    }

    const normalizedUrl = url.trim();
    if (normalizedUrl && isAbsoluteHttpUrl(normalizedUrl)) {
      result.push(normalizedUrl);
    }

    return result;
  }, []);
};

export const parseWelcomeImageUrls = rawValue => {
  if (!rawValue || !rawValue.toString().trim()) {
    return [];
  }

  try {
    return normalizeWelcomeImageUrls(JSON.parse(rawValue));
  } catch {
    return [];
  }
};

export const isValidWelcomeImageUrlsJson = rawValue => {
  if (!rawValue || !rawValue.toString().trim()) {
    return true;
  }

  try {
    const parsedValue = JSON.parse(rawValue);

    return (
      Array.isArray(parsedValue) &&
      parsedValue.every(
        url =>
          typeof url === 'string' &&
          url.trim().length > 0 &&
          isAbsoluteHttpUrl(url.trim())
      )
    );
  } catch {
    return false;
  }
};

export const getWelcomeImageUrlsForInput = ({ rawValue }) =>
  parseWelcomeImageUrls(rawValue);

export const resolveWelcomeImageUrl = ({
  welcomeImageUrls = [],
  selectionSeed = WELCOME_IMAGE_SELECTION_SEED,
}) => {
  const normalizedUrls =
    typeof welcomeImageUrls === 'string'
      ? parseWelcomeImageUrls(welcomeImageUrls)
      : normalizeWelcomeImageUrls(welcomeImageUrls);

  if (!normalizedUrls.length) {
    return '';
  }

  return normalizedUrls[
    getImageSelectionIndex({ options: normalizedUrls, selectionSeed })
  ];
};
